import axiosInstance from "src/common/axiosInstance";

const contactService = {
  /* =====================================================
     BASE URL
  ===================================================== */

  getBaseUrl(workspaceId, whatsappAccountId, phoneNumberId) {
    return `/workspaces/${workspaceId}/whatsapp-accounts/${whatsappAccountId}/phone-numbers/${phoneNumberId}/contacts`;
  },

  /* =====================================================
     GET ALL CONTACTS
     Server pagination and filters cover the entire authorised directory
  ===================================================== */

  index(workspaceId, whatsappAccountId, phoneNumberId, params = {}) {
    return axiosInstance.get(
      this.getBaseUrl(workspaceId, whatsappAccountId, phoneNumberId),
      { params },
    );
  },

  /* =====================================================
     GET SINGLE CONTACT
  ===================================================== */

  show(workspaceId, whatsappAccountId, phoneNumberId, contactId) {
    return axiosInstance.get(
      `${this.getBaseUrl(
        workspaceId,
        whatsappAccountId,
        phoneNumberId,
      )}/${contactId}`,
    );
  },

  /* =====================================================
     CREATE CONTACT
  ===================================================== */

  store(workspaceId, whatsappAccountId, phoneNumberId, payload) {
    return axiosInstance.post(
      this.getBaseUrl(workspaceId, whatsappAccountId, phoneNumberId),
      payload,
    );
  },

  /* =====================================================
     UPDATE CONTACT
  ===================================================== */

  update(workspaceId, whatsappAccountId, phoneNumberId, contactId, payload) {
    return axiosInstance.put(
      `${this.getBaseUrl(
        workspaceId,
        whatsappAccountId,
        phoneNumberId,
      )}/${contactId}`,
      payload,
    );
  },

  /* =====================================================
     DELETE CONTACT
  ===================================================== */

  destroy(workspaceId, whatsappAccountId, phoneNumberId, contactId) {
    return axiosInstance.delete(
      `${this.getBaseUrl(
        workspaceId,
        whatsappAccountId,
        phoneNumberId,
      )}/${contactId}`,
    );
  },

  /* =====================================================
     IMPORT — fetch + parse a public Google Sheet
     (server-side; the browser can't fetch docs.google.com)
  ===================================================== */

  fetchGoogleSheet(workspaceId, whatsappAccountId, phoneNumberId, url) {
    return axiosInstance.post(
      `${this.getBaseUrl(
        workspaceId,
        whatsappAccountId,
        phoneNumberId,
      )}/import/google-sheet`,
      { url },
    );
  },

  /* =====================================================
     IMPORT — map rows onto our fields and upsert.
     payload: { mapping, metadata_columns, rows }
  ===================================================== */

  import(workspaceId, whatsappAccountId, phoneNumberId, payload) {
    return axiosInstance.post(
      `${this.getBaseUrl(
        workspaceId,
        whatsappAccountId,
        phoneNumberId,
      )}/import`,
      payload,
    );
  },
};

export default contactService;
